<!-- <nb-layout>
    <nb-layout-column class="kak-spotter"> -->
        <div class="input-panel-container">
            <nb-card>
              <nb-card-header *ngIf="!hasSelections">
                <h6>{{ getHeaderText() }}</h6>
              </nb-card-header>
              <nb-card-body>
                <!-- Product Description for Category Recommendation Section -->
                <div class="input-section" *ngIf="currentStep === 'category'">
                  <ng-container *ngIf="!hasSelections">
                    <p class="section-description">
                      You have selected categories. Please provide a short description of your product to refine the recommendations.
                    </p>
                  </ng-container>
                  <nb-form-field>
                    <textarea
                      nbInput
                      fullWidth
                      placeholder="Describe your product (e.g., 'Men's waterproof hiking boots with Gore-Tex lining')"
                      [(ngModel)]="categoryInput"
                      [disabled]="isLoading"
                      rows="3"
                    ></textarea>
                  </nb-form-field>
                  <div class="actions">
                    <ng-container *ngIf="categoryInput.trim()">
                      <button
                        nbButton
                        status="primary"
                        [disabled]="!categoryInput.trim() || isLoading"
                        (click)="onProductDescriptionSubmit()"
                        [nbSpinner]="isLoading"
                        nbSpinnerStatus="primary"
                        nbSpinnerSize="small">
                        Get Category Recommendations
                      </button>
                    </ng-container>
                    
                  </div>
                </div>
          
                <!-- Features Selection Section -->
                <div class="input-section" *ngIf="currentStep === 'features'">
                  <div class="features-grid">
                    <nb-checkbox 
                      *ngFor="let feature of features"
                      [checked]="isFeatureSelected(feature)"
                      (checkedChange)="toggleFeature(feature)"
                      [disabled]="isLoading"
                    >
                      {{ feature }}
                    </nb-checkbox>
                  </div>
                  <div class="actions">
                    <button
                      nbButton
                      status="primary"
                      [disabled]="selectedFeatures.length === 0 || isLoading"
                      (click)="onFeaturesSelect()"
                      [nbSpinner]="isLoading"
                      nbSpinnerStatus="primary"
                      nbSpinnerSize="small"
                    >
                      Continue
                    </button>
                  </div>
                </div>
          
                <!-- Description Section -->
                <div class="input-section" *ngIf="currentStep === 'description'">
                  <nb-form-field>
                    <textarea
                      nbInput
                      fullWidth
                      placeholder="Describe your requirements in detail..."
                      [(ngModel)]="descriptionText"
                      [disabled]="isLoading"
                      rows="5"
                    ></textarea>
                  </nb-form-field>
                  <div class="upload-section">
                    <p class="upload-label">Or upload an image:</p>
                    <div class="file-upload-container">
                      <input
                        type="file"
                        #fileInput
                        accept="image/*"
                        (change)="onFileSelected($event)"
                        [disabled]="isLoading"
                        class="file-input"
                      />
                      <div class="upload-placeholder" (click)="fileInput.click()" *ngIf="!selectedFile">
                        <nb-icon icon="upload-outline"></nb-icon>
                        <p>Click to upload an image</p>
                      </div>
                      <div class="selected-file" *ngIf="selectedFile">
                        <div class="file-preview">
                          <img [src]="previewUrl" alt="Preview" />
                        </div>
                        <div class="file-info">
                          <span>{{ selectedFile.name }}</span>
                          <button nbButton ghost size="small" (click)="removeFile()">
                            <nb-icon icon="close-outline"></nb-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="actions">
                    <button
                      nbButton
                      status="primary"
                      [disabled]="(!descriptionText.trim() && !selectedFile) || isLoading"
                      (click)="selectedFile ? onImageSubmit() : onTextSubmit()"
                      [nbSpinner]="isLoading"
                      nbSpinnerStatus="primary"
                      nbSpinnerSize="small"
                    >
                      Submit
                    </button>
                  </div>
                </div>
                <!-- Catalog -->
                <div class="input-section" *ngIf="currentStep === 'catalog'">
                  <ng-container *ngIf="!hasMessages">
                    <p class="section-description">
                      Enter a comma separated list of products representative of your product range and we will recommend a product catalogue tree from which you can select applicable categories.
                    </p>
                  </ng-container>
                  
                  <nb-form-field>
                    <textarea
                      nbInput
                      fullWidth
                      placeholder="Supply a select product list, comma separated (e.g., 'Shoes, Boots, Sandals, Sneakers, Slippers')"
                      [(ngModel)]="catalogInput"
                      [disabled]="isLoading"
                      rows="3"
                    ></textarea>
                  </nb-form-field>
                  <div class="actions">
                    <ng-container *ngIf="catalogInput.trim()">
                      <button
                        nbButton
                        status="primary"
                        [disabled]="!catalogInput.trim() || isLoading"
                        (click)="onProductListSubmit()"
                        [nbSpinner]="isLoading"
                        nbSpinnerStatus="primary"
                        nbSpinnerSize="small">
                        Get Catalog Recommendations
                      </button>
                    </ng-container>
                    
                  </div>
                </div>
              </nb-card-body>
            </nb-card>
          </div>
<!--     </nb-layout-column>
    
</nb-layout> -->
